export default "__VITE_ASSET__DYFMvq3S__"